import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockContent: [
		{
			question: 'Кой може да стане партньор?',
			answer: `
				Всеки уеб разработчик, агенция или фрийлансър, който работи с клиенти и препоръчва хостинг услуги.
			`
		},
		{
			question: 'Трябва ли да съм фирма?',
			answer: `
				Не е задължително, но за изплащане на комисиони е необходимо да издадеш фактура.
			`
		},
		{
			question: 'До кога мога да асоциирам клиент?',
			answer: `
				Имаш 90 дни от активирането на услугата, за да го свържеш с профила си.
			`
		},
		{
			question: 'Какво ако клиентът вече е в Superhosting?',
			answer: `
				Свържи се с търговски отдел на sales@superhosting.bg за ръчно асоцииране.
			`
		},
		{
			question: 'Как получавам парите?',
			answer: `
				При над 100 евро без ДДС поискай изплащане срещу фактура, или ги използвай за твои услуги при нас.
			`
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockContent: [
		{
			question: 'Who can become a partner?',
			answer: `
				Any web developer, agency, or freelancer who works with clients and recommends hosting services.
			`
		},
		{
			question: 'Do I need to be a registered business?',
			answer: `
				No, it is not required. However, you need to issue an invoice in order to receive commission payments.
			`
		},
		{
			question: 'How long do I have to associate a client?',
			answer: `
				You have 90 days from the date the service is activated to associate the client with your account.
			`
		},
		{
			question: 'What if the client is already a SuperHosting customer?',
			answer: `
				Contact our Sales team at sales@superhosting.bg to request manual association.
			`
		},
		{
			question: 'How do I receive my commission?',
			answer: `
				Once your commission balance exceeds €100 excluding VAT, you can request a payout by issuing an invoice, or use the amount towards your own services with us.
			`
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];